function Maintenance() {
  return (
    <div className="maintenance">
      <div className="maintenance-dialog">
        <h1>Beste darters,</h1>
        <p>
          Momenteel is er een technische fout, waardoor het niet mogelijk is om
          de applicatie te gebruiken.
        </p>
        <p>We werken aan een oplossing.</p>
        <strong>Update:</strong> vrijdag 3 maart, 13:01
      </div>
    </div>
  );
}

export default Maintenance;
